import React, { useCallback, useEffect, useRef, useState } from "react";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { Ifilter } from "../../../../../Interfaces/filter";
import personaServicio from "../../../../../services/persona/personaServicio";
import { IComboPersona } from "../../../../../Interfaces/IPersona";

const UseComboOperador = (isOpen: boolean, isClaveEnrolar: boolean = false) => {
    const controllerRef = useRef<AbortController>(new AbortController());
    const [filterOperador, setFilterOperador] = useState<IComboPersona>({
        skip: 0,
        take: 20,
        search: null,
        isClaveEnrolar: isClaveEnrolar
    });
    const [dataComboOperador, setDataComboOperador] = useState<IComboBoxOption[]>([]);
    

    const comboBoxRefOperador = useRef<IComboBox>(null);
    const onClickComboOperador = () => comboBoxRefOperador.current?.focus(true);
    const _openOption = useCallback(() => comboBoxRefOperador.current?.focus(true), []);
    const _onkeyUpSearchOperador = (event: React.KeyboardEvent<IComboBox>) => {
        if (event.code === "Escape") {
            comboBoxRefOperador.current?.focus(false);
            setFilterOperador({
                skip: 0,
                take: 20,
                search: null,
                isClaveEnrolar: isClaveEnrolar
            });
        } else {
            _openOption();
            let { value } = event?.target as HTMLInputElement;
            setFilterOperador({ ...filterOperador, search: value });
        }
    };

    const listarCombo = () => {
        controllerRef.current.abort();
        const newController = new AbortController();
        controllerRef.current = newController;
        personaServicio.ComboPersona(filterOperador).then((res) => {
            if (res.status === 200) {
                setDataComboOperador(res.data);
            }
        });
    };

    useEffect(() => {
        if (isOpen) {
            listarCombo();
        }
    }, [isOpen]);
    
    useEffect(()=>{
        if(filterOperador.search!=null){
            listarCombo()
        }
    },[filterOperador])

    return {
        dataComboOperador,
        onClickComboOperador,
        _onkeyUpSearchOperador,
        comboBoxRefOperador,filterOperador,setFilterOperador
    };
}

export { UseComboOperador }
